<template>
  <b-modal
    title="HISTORIAL DE AUMENTOS"
    modal-class="modal-primary"
    hide-footer
    @hidden="$emit('close')"
    size="xl"
    scrollable
    v-model="showModal"
  >
    <div class="mb-2 mt-1">
      <b-row>
        <b-col lg="12">
          <b-input-group class="mb-1">
            <template #prepend>
              <b-input-group-text class="prepend__width">
                <strong>NAME</strong>
              </b-input-group-text>
            </template>
            <b-form-input :value="modalData.full_name" disabled />
          </b-input-group>
        </b-col>
      </b-row>
    </div>
    <div class="table-responsive">
      <b-table
        small
        sticky-header="50vh"
        class="position-relative"
        table-class="text-nowrap"
        :items="items"
        empty-text="No se encontraron registros"
        :fields="fields"
      >
        <template #cell(fecha_cese)="d">
          <span>{{ d.item.fecha_cese | myGlobal }}</span>
        </template>

        <template #cell(fecha_generada)="d">
          <span>{{ d.item.fecha_generada | myGlobal }}</span>
        </template>

        <template #cell(created_at)="d">
          <span>{{ d.item.created_at | myGlobal }}</span>
        </template>

        <template #cell(estado)="d">
          <b-badge
            pill
            :variant="`light-${resolvStyleStatus(d.item.estado.toLowerCase())}`"
          >
            {{ d.item.estado }}
          </b-badge>
        </template>
      </b-table>
    </div>
  </b-modal>
</template>

<script>
/* Service */
import EmployeeService from "@/views/rrhh/views/employees/services/employee.service.js";

export default {
  props: {
    modalData: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      items: [],
      fields: [
        {
          key: "fecha_cese",
          label: "Fecha de cese",
          visible: true,
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          key: "fecha_generada",
          label: "Fecha generada",
          visible: true,
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          key: "sueldo_pendiente",
          label: "Sueldo pendiente",
          visible: true,
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          key: "vacaciones_truncas",
          label: "Vacaciones truncas",
          visible: true,
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          key: "gratificacion_trunca",
          label: "Gratificación trunca",
          visible: true,
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          key: "cts_trunca",
          label: "CTS trunca",
          visible: true,
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          key: "asignacion_familiar",
          label: "Asignación familiar",
          visible: true,
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          key: "otros_bonos",
          label: "Otros bonos",
          visible: true,
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          key: "total_liquidacion",
          label: "Total liquidación",
          visible: true,
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          key: "estado",
          label: "Estado",
          visible: true,
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          key: "created_by",
          label: "Registrado por",
          visible: true,
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          key: "created_at",
          label: "Fecha creación",
          visible: true,
          tdClass: "text-center",
          thClass: "text-center",
        },
      ],
      showModal: true,
    };
  },
  async created() {
    await this.getHistorialLiquidaciones();
  },
  computed: {
    showFields() {
      return this.fields.filter((item) => item.visible);
    },
  },
  methods: {
    async getHistorialLiquidaciones() {
      try {
        this.addPreloader();
        const { data } = await EmployeeService.getHistorialLiquidaciones({
          employee_id: this.modalData.id,
        });
        console.log(data);
        this.items = data;
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },
    resolvStyleStatus(status) {
      let val = "success";

      switch (status.toUpperCase()) {
        case "PENDIENTE":
          val = "warning";
          break;
        case "APROBADO":
          val = "info";
          break;
        case "PAGADO":
          val = "success";
          break;
        case "ANULADO":
          val = "danger";
          break;
        default:
          break;
      }

      return val;
    },
  },
};
</script>
